<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item"><router-link to="/purchase/orders">{{ $t('purchase_order_list') }}</router-link></li>
            <li class="breadcrumb-item active" aria-current="page">{{title}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <b-btn variant="outline-primary no-bor" size="sm" @click="save"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</b-btn>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="control-label blue">{{ $t('vendor') }}</label>
                                <div>
                                    <vendor-selector @select="vendorSelected" :value="header.PartnerName"></vendor-selector>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="control-label blue">{{$t('ship_to')}}</label>
                                <div>
                                    <select class="form-control form-control-sm"  v-model="header.BranchId">
                                        <option value=""></option>
                                        <option v-for="ret in branches" :value="ret.Id" :key="ret.Id">{{ret.Name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="control-label blue">{{$t('date')}}</label>
                                <div>
                                    <input type="date" class="form-control form-control-sm" v-model="date"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="grid">
                                <thead>
                                    <tr class="blue">
                                        <th style="width: 30px;"></th>
                                        <th class="blue">{{$t('item_name')}}</th>
                                        <th>{{$t('description')}}</th>
                                        <th style="width: 100px;">{{$t('qty')}}</th>
                                        <th style="width: 120px;">{{$t('uom')}}</th>
                                        <th style="width: 100px;">{{$t('unit_price')}}</th>
                                        <th class="text-right" style="width: 100px;">{{$t('amount')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ret,index) in lines" :key="ret.Id">
                                        <td style="width: 30px;">
                                            <button type="button" class="btn btn-danger btn-remove" @click="onRemove(index)">X</button>
                                        </td>
                                        <td><AuthCompleted @select="itemSelect($event, ret)" :value="ret.ItemName"></AuthCompleted></td>
                                        <td class="text-center">
                                            <input type="text" class="form-control form-control-sm" v-model="ret.Description" :disabled="ret.ItemId==''">
                                        </td>
                                        <td class="text-center">
                                            <input type="number" class="form-control form-control-sm" v-model="ret.Quantity" @keypress="$isKeyNumber" @change="reCalculate" :disabled="ret.ItemId==''">
                                        </td>
                                        <td>
                                            <UomDropdown :value="ret.UomName" :item_id="ret.ItemId" @select="uomChange($event, ret)"></UomDropdown>
                                        </td>
                                        <td class="text-right">
                                            <input type="number" class="form-control form-control-sm" v-model="ret.Price" @keypress="$isKeyNumber" @change="reCalculate" :disabled="ret.ItemId==''">
                                        </td>
                                        <td class="text-right">
                                            <input type="text" class="form-control form-control-sm text-right" :value="$money(ret.SubTotal)" readonly />
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colspan="4" rowspan="3" style="vertical-align: top;">
                                            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="addLine"><i class="fa fa-plus"></i> {{ $t('add_line') }}</button>
                                        </td>
                                        <th colspan="2" class="text-right">{{$t('untax_amount')}}:</th>
                                        <th class="text-right">{{$money(header.GrandTotal)}}</th>
                                    </tr>
                                    <tr>
                                        <th colspan="2" class="text-right">{{$t('total')}}:</th>
                                        <th class="text-right">{{$money(header.PaidAmount)}}</th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { AuthCompleted } from '../Item';
import { VendorSelector } from '../Vendors';
import UomDropdown from '../UOM/Dropdown';
export default {
    components: {
        AuthCompleted,
        VendorSelector,
        UomDropdown
    },
    data: function(){
        return {
            title: this.$t('purchase_order_create'),
            header: {
                VendorId: '',
                BranchId: '',
                PartnerName: '',
                Phone: '',
                GrandTotal: 0,
                TaxVat: 0,
                PaidAmount: 0
            },
            lines: [{
                ItemId: '',
                ItemName: '',
                Description: '',
                UomId: '',
                UomName: '',
                Quantity: 1,
                Price: 1,
                Discount: 0,
                TaxLine: 0,
                SubTotal: 1
            }],
            date: this.$now().format('YYYY-MM-DD'),
            branches: []
        }
    },
    created(){
        let id = this.$route.params.id;
        this.branchList();
        if(id != undefined && id != null && id != ''){
            let loading = this.$loading.show();
            this.$api().post('purchase/order/find', { Id: id }).then(res => {
                if(this.$isValid(res)){
                    let data = res.data.Json;
                    this.header = data.Header;
                    this.lines = data.Lines;
                    this.title = this.$t('purchase_order_update') +' ['+ this.header.Num + ']';
                }
            }).finally(function(){ loading.hide(); });
        }
    },
    methods: {
        addLine(){
            this.lines.push({
                ItemId: '',
                ItemName: '',
                Description: '',
                UomId: '',
                UomName: '',
                Quantity: 1,
                Price: 1,
                Discount: 0,
                TaxLine: 0,
                SubTotal: 1
            });
        },
        save(){
            if(this.lines.length > 0){
                let loading = this.$loading.show();
                this.header.Date = this.date;
                var req = {
                    Header: this.header,
                    Lines: this.lines
                };
                this.$api().post('purchase/order/save', req).then(res => {
                    if(this.$isValid(res)){
                        this.$router.push('/purchase/orders');
                    }
                }).finally(function() { loading.hide();});
            }
        },
        vendorSelected(evt){
            this.header.VendorId = evt.Id;
            this.header.PartnerName = evt.Name;
            this.header.Phone = evt.Phone;
        },
        reCalculate(){
            let grand_total = 0;
            let taxs = 0;
            let total = 0;
            let discount = 0;
            this.lines.map(item => {
                let grand = Number(item.Quantity) * Number(item.Price);
                let dis = grand * (item.Discount / 100);
                let line_untax = grand - dis;
                let line_tax = line_untax * (item.TaxLine / 100);
                let line_sub = line_untax + line_tax;
                item.SubTotal = line_sub;
                grand_total += grand;
                discount += dis;
                taxs += line_tax;
                total += line_sub;
            });
            this.header.Discount = discount;
            this.header.GrandTotal = grand_total;
            this.header.TaxVat = taxs;
            this.header.PaidAmount = total;
        },
        itemSelect(evt, line){
            line.ItemId = evt.Id;
            line.ItemName = evt.Name;
            line.UomId = evt.UomId;
            line.UomName = evt.UomName;
            line.Price = evt.Cost;
            this.reCalculate();
        },
        onRemove(index){
            this.lines.splice(index, 1);
            this.reCalculate();
        },
        uomChange(e, line){
            line.UomId = e.UomId;
            line.UomName = e.UomName;
            line.Price = e.Cost;
            this.reCalculate();
        },
        branchList: async function(){
            var res = await this.$api().post('branch/list', { Limit: 0 });
            if(this.$isValid(res)){
                this.branches = res.data.Data;
            }
        }
    }
}
</script>
